import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-video-background',
  templateUrl: './video-background.component.html',
  styleUrls: ['./video-background.component.scss']
})
export class VideoBackgroundComponent {
  videoUrl = 'https://video.wixstatic.com/video/11062b_6743da5900054f1f8e69f53302930a6a/1080p/mp4/file.mp4';
  posterImage = 'https://static.wixstatic.com/media/11062b_6743da5900054f1f8e69f53302930a6af000.jpg/v1/fill/w_1513,h_463,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_6743da5900054f1f8e69f53302930a6af000.jpg';
  @ViewChild('backgroundVideo') videoRef!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit() {
    this.setupVideoAutoplay();
  }

  private setupVideoAutoplay() {
    const video = this.videoRef.nativeElement;
    
    // Modern browsers require promise-based play
    const playPromise = video.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        // Autoplay was prevented - mute and try again
        video.muted = true;
        video.play().catch(e => console.log('Autoplay prevented:', e));
      });
    }
  }

  joinUs() {
    window.open('https://play.google.com/store/apps/details?id=com.calsoft.ecom.CalsoftSuperApp', '_blank');
  }

  learnMore() {
    // Add your learn more functionality here
    console.log('Learn more clicked');
  }
}
